<template>
  <div class="page">
    <a name="benchmark-holdings"/>
    <p class="dustin preheader">
      Appendix B - Benchmark Holdings
    </p>
    <p class="dustin-title">
      {{benchmark.name}}
    </p>
    As of {{ benchmark.holdings_as_of_date }}
    <!-- <p class="preheader">
      Add total value back laer
      $1,532,246 value
    </p> -->

    <section class="section">

        <table class="table is-fullwidth">
          <thead class="has-text-centered">
            <th>Name</th>
            <th>Ticker</th>
            <th>Category</th>
            <th v-if="dollarsOrPercentagesChoice == 'dollars'">USD</th>
            <th v-if="dollarsOrPercentagesChoice == 'percentages'">Percentage</th>
            <!-- <th>%</th> -->
          </thead>
          <tbody>
            <tr
              v-for="(entry, index) in holdings"
              v-bind:key="`${entry.id}-${index}`"
            >
              <td>{{entry.ticker.full_name || entry.ticker.company_name}}</td>
              <td>{{entry.ticker.symbol}}</td>
              <td>{{entry.ticker.benchmark_description}}</td>
              <td v-if="dollarsOrPercentagesChoice == 'dollars'">{{entry.dollars.toLocaleString('en-US', {style: 'currency', currency: 'USD', maximumFractionDigits: 0})}}</td>
              <td v-if="dollarsOrPercentagesChoice == 'percentages'">{{entry.percent_owned.toFixed(2)}}%</td>
              <td></td>
            </tr>
          </tbody>
        </table>

    </section>
  </div>
</template>

<script>
  import eventBus from '@frontend/shared/EventBus.js';

  export default {
    data () {
      return {
        ready: false,
      }
    },
    name: 'BenchmarkHoldings',
    props: {
      benchmark: Object,
      dollarsOrPercentagesChoice: 'dollars',
    },
    mounted: function() {
      this.$nextTick(() => {
        eventBus.$emit('InstitutionalReport:page-rendered', this.$options.name);
      });
    },
    computed: {
      holdings: function() {
        return this.benchmark.holdings.filter((itm) => {
          return itm.dollars > 0;
        })
      },
      portfolioValue: function() {
        return this.benchmark.holdings.reduce((acc, itm) => {
          return acc + itm.dollars;
        }, 0);
      }
    }
  }
</script>

<style lang="css" scoped>
</style>
